import { render, staticRenderFns } from "./subjectSettingsWin.vue?vue&type=template&id=129e8984&scoped=true&"
import script from "./subjectSettingsWin.vue?vue&type=script&lang=js&"
export * from "./subjectSettingsWin.vue?vue&type=script&lang=js&"
import style0 from "./subjectSettingsWin.vue?vue&type=style&index=0&id=129e8984&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129e8984",
  null
  
)

export default component.exports